import React, { useContext, useCallback, useState } from 'react';
import { Typography, TextField, Button } from '@material-ui/core';
import { useHistory } from 'react-router';
import { FieldView } from '../../../types/FieldView';
import { GlobalsContext } from '../../../store/Globals';
import { LinkContainer } from './styles';
import ObjectModal from '../../List/ObjectModal';

const SingleField: React.FC<{
  tag: string;
  label: string;
  parent: number;
  dataType: string;
  value: string | FieldView[] | FieldView;
}> = ({ label, value, tag, parent, dataType }) => {
  const globals = useContext(GlobalsContext);
  const history = useHistory();
  const [object, setObject] = useState<string | null>(null);

  const isValueAssetString = useCallback(() => {
    const divValue: string[] = (value as string).split(':');

    if (divValue.length >= 1) {
      return globals.assetList.some((asset) => asset.tag === divValue[0]);
    }

    return false;
  }, [value, globals]);

  const isAsset = useCallback(() => {
    const valueType = typeof value;
    return (
      (valueType === 'string' && isValueAssetString()) ||
      (valueType === 'object' && !Array.isArray(value))
    );
  }, [value, isValueAssetString]);

  return (
    <div id={tag} style={{ marginLeft: `${30 * parent}px` }}>
      {isAsset() ? (
        <>
          <Typography style={{ fontWeight: 'bold' }}>{label}</Typography>

          <div style={{ margin: '5px' }}>
            {typeof value === 'object' &&
            '@assetType' in value &&
            value['@assetType'] === '@object' ? (
              <Button
                disabled={false}
                variant="outlined"
                onClick={(e: any) => {
                  if (e.currentTarget) setObject(e.currentTarget.value);
                }}
                value={JSON.stringify(value)}
              >
                <i className="bx bx-show" style={{ marginRight: '4px' }}></i>
                @Object
              </Button>
            ) : (
              <Button
                variant="outlined"
                onClick={() => {
                  if (typeof value === 'object' && (value as any)['@key']) {
                    history.push(`/show/${(value as any)['@key']}`);
                  } else {
                    history.push(`/show/${value}`);
                  }
                }}
              >
                <i className="bx bx-show" style={{ marginRight: '4px' }}></i>

                {typeof value === 'string'
                  ? value
                  : globals.itemLabel(value, true)}
              </Button>
            )}
          </div>
        </>
      ) : typeof value !== 'object' ? (
        dataType === '[]url' || dataType === 'url' ? (
          <LinkContainer>
            <a href={value} target="_blank" rel="noopener noreferrer">
              <TextField
                disabled
                fullWidth
                label={label}
                value={value}
                InputProps={{ style: { color: '#000' } }}
                InputLabelProps={{ style: { color: '#000' } }}
              />
            </a>
          </LinkContainer>
        ) : (
          <>
            <TextField
              disabled
              fullWidth
              multiline
              label={label}
              value={value}
              InputProps={{ style: { color: '#000' } }}
              InputLabelProps={{ style: { color: '#000' } }}
            />
          </>
        )
      ) : Array.isArray(value) ? (
        value.length > 0 && typeof value[0] === 'string' ? (
          <div style={{ padding: '8px 0' }}>
            <Typography
              style={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#757575',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                marginBottom: '6px',
              }}
            >
              {label}
            </Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {(value as any[]).map((item: any, idx: number) => (
                <span
                  key={`${item}${idx}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px',
                    padding: '4px 10px 4px 8px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '20px',
                    background: '#fafafa',
                    fontSize: '12px',
                    color: '#424242',
                  }}
                >
                  <i className="bx bxs-circle" style={{ fontSize: '6px', color: '#66bb6a' }} />
                  {String(item)}
                </span>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ margin: '5px' }}>
            <Typography style={{ fontWeight: 'bold' }}>{label}</Typography>

            {value.length > 0
              ? value.map((item, idx) => {
                  return (
                    <div
                      key={`${item.tag}${idx}`}
                      style={{ marginLeft: `${30 * parent}px` }}
                    >
                      <SingleField
                        tag={item.tag}
                        label={item.label}
                        parent={parent + 1}
                        dataType={dataType}
                        value={
                          typeof item !== 'object'
                            ? item
                            : (item as Record<string, any>)['@key']
                        }
                      />
                    </div>
                  );
                })
              : null}
          </div>
        )
      ) : null}
      <ObjectModal
        object={object}
        setObject={(objectData: string | null) => setObject(objectData)}
      />
    </div>
  );
};

export default SingleField;
